// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
//MD5加密
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookie from 'vue-cookies';
import VirtualScroll from 'el-table-virtual-scroll';
//全局引入自定义组件
import '@/assets/css/reset.css';
import router from './router';
import store from './store';
import i18n from './i18n';
import bootstrap from './core';
import Http from './plugins/http.js';
import cusInstall from './plugins/cus-component';
import VueMeta from 'vue-meta';

import './router/permission';
import './utils/filter';
// 引用api文件
// import api from './api/index';
// Vue.prototype.$api = api;
import outToExcel from './utils/outToExcel';
import axios from 'axios';
import directives from '@/utils/directives';

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
  contentSecurityPolicy: {
    defaultSrc: ["'self'"],
    scriptSrc: ["'self'", "'unsafe-inline'"],
    styleSrc: ["'self'", "'unsafe-inline'"],
    imgSrc: ["'self'"],
    connectSrc: ["'self'"],
    fontSrc: ["'self'"],
    objectSrc: ["'none'"],
    mediaSrc: ["'self'"]
  }
});
Vue.prototype.outToExcels = outToExcel;
Vue.prototype.$http = Http;
Vue.prototype.$md5 = md5;
Vue.prototype.$defaultPaginationSize = 100;
Vue.prototype.keys = {
  current_user: {
    token: 'token',
    user: 'user',
    menus: []
  }
};
Vue.prototype.$getStatus = (list, code) => {
  if (!list) return '';
  let az = list.filter((it) => it.value == code);
  let [item] = az;
  return item ? item.label : '';
};
Vue.prototype.$axios = axios;
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
Vue.use(cusInstall);
Vue.use(VueCookie);
Vue.use(VirtualScroll);
Vue.component('virtual-scroll', VirtualScroll);

// Vue.use(MyServerHttp);
Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

//根据不同域名 设置网页图标和标题
function setFaviconAndTitle(domain) {
  const link = document.querySelector("link[rel~='icon']");

  // 创建一个新的 link 元素
  const newLink = document.createElement('link');
  newLink.rel = 'icon';
  if (domain.includes('kpay') || domain.includes('kpayvn') || domain.includes('kpayvn01')) {
    document.title = 'Kpay商户后台';
    newLink.href = `/static/KPAY-Favicon-32x32.png`; // 根据域名设置不同的图标路径
  } else if (domain.includes('pfpay01') || domain.includes('unlpay')) {
    document.title = 'UnlPay商户后台';
    newLink.href = `/static/upayicon.png`; // 根据域名设置不同的图标路径
  } else if (
    domain.includes('epayment') ||
    domain.includes('epayment365') ||
    domain.includes('epay')
  ) {
    document.title = 'E-Payment商户后台';
    newLink.href = `/static/epay.png`; // 根据域名设置不同的图标路径
  } else if (domain.includes('xcpay') || domain.includes('xcPay') || domain.includes('xcPAY')) {
    document.title = 'xcpay商户后台';
    newLink.href = `/static/xcpay.jpg`; // 根据域名设置不同的图标路径
  } else if (
    ['ttpay', 'tt-pay', 'ttpays', 'TTpay', 'TTPAY'].some((substring) => domain.includes(substring))
  ) {
    document.title = 'TTPAY商户后台';
    newLink.href = `/static/TTpay.ico`;
  } else {
    document.title = 'chaoyuePay商户后台';
    newLink.href = `/static/chaoyue.jpg`; // 根据域名设置不同的图标路径
  }

  // 如果已经存在 link 元素，则替换为新的图标
  if (link) {
    document.head.removeChild(link); // 先移除旧的 link 元素
  }

  // 添加新的 link 元素到 head 中
  document.head.appendChild(newLink);
}
// 在 Vue 实例化之前执行设置网页图标和标题的方法
// 确保 DOM 完全加载后执行
document.addEventListener('DOMContentLoaded', () => {
  const currentDomain = window.location.hostname;
  setFaviconAndTitle(currentDomain);
});

// 注册全局指令
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  created: bootstrap,
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js